import { DownloadOutlined, ReloadOutlined } from '@ant-design/icons';
import {
  Button, Empty, Spin, Typography
} from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useSearchParams } from 'react-router-dom';

import HeaderPage from 'common/components/HeaderPage';
import { getExportByCodeService } from 'common/services/extends/exports';
import { downloadFile, mappingURLToExternal } from 'common/utils/functions';

interface PreviewXLSXProps {
}

const PreviewXLSX: React.FC<PreviewXLSXProps> = () => {
  const { t } = useTranslation();
  const [searchParam] = useSearchParams();
  const code = searchParam.get('code') || '';
  const [reloadKey, setReloadKey] = useState(0);

  const { data, isLoading } = useQuery(
    ['preview-xlsx-by-code', code],
    () => getExportByCodeService(code),
    {
      enabled: !!code,
    }
  );

  const handleExport = () => {
    if (!data?.downloadUrl) return;
    const nameFromUrl = data?.downloadUrl.split('/').pop();
    downloadFile(mappingURLToExternal(data?.downloadUrl), nameFromUrl);
  };

  return (
    <div>
      <HeaderPage
        fixed
        title={data?.fileName || t('system.preview')}
        rightHeader={(
          <>
            <Button
              icon={<ReloadOutlined />}
              onClick={() => setReloadKey((key) => key + 1)}
            >
              {t('exportReports.reloadPreview')}
            </Button>
            <Button
              type="primary"
              onClick={handleExport}
            >
              <DownloadOutlined />
              {t('system.exportFile')}
            </Button>
          </>
        )}
      />
      <Spin spinning={isLoading}>
        <div className="t-mainlayout_wrapper" style={{ height: 'calc(100vh - 120px)' }}>
          {/* Preview by iframe */}
          {
            data?.downloadUrl ? (
              <>
                <Typography.Text type="secondary">
                  {t('exportReports.previewHint')}
                </Typography.Text>
                <iframe
                  key={reloadKey}
                  title={data.fileName}
                  width="100%"
                  height="100%"
                  src={`https://view.officeapps.live.com/op/embed.aspx?src=${mappingURLToExternal(data?.downloadUrl)}`}
                />
              </>
            ) : (
              <Empty
                description={t('message.fileNotFound')}
                style={{ height: '100%' }}
              />
            )
          }
        </div>
      </Spin>
    </div>
  );
};

export default PreviewXLSX;
